import styled, { css } from 'styled-components'
import { customTheme } from '../../../styles/theme'

interface IVisibleElement {
  isShowing: boolean;
}

interface IContainerProps {
  type: 'small' | 'medium' | 'large';
}

export const OverlayWrapper = styled.div<IVisibleElement>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 999999;

  display: ${({ isShowing }) => isShowing ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  
  background: rgba(0, 0, 0, 0.55);
`

export const Container = styled.div<IContainerProps>`
  width: 90%;
  height: 70vh;

  ${({ type }) => {
    if (type === 'small') {
      return css`
        width: 90%;
        height: 65vh;
      `
    } else if (type === 'medium') {
      return css`
        width: 90%;
        height: 75vh;
      `
    } else {
      return css`
        width: 90%;
        height: 95%;
      `
    }
  }}

  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;

  background: ${customTheme.colors.black};
  border-radius: 20px;
`

export const Image = styled.img`
  max-height: 100%;
  max-width: 100%;
  height: 100%;

  object-fit: contain;
`

export const Close = styled.button`
  position: absolute;
  top: 4.5%;
  right: 2%;

  width: 50px;
  height: 50px;

  background: #FF4C61;
  border-radius: 63px;
  border: 14px solid #fff;
  cursor: pointer;
`
